module.exports = __webpack_public_path__ + "img/toCase.f41adbf2.png";